/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { PanelCard } from '../../../design-system/molecules/PanelCard/PanelCard';
import { CodeBlock } from '../../../design-system/atoms/CodeBlock/CodeBlock';
import { hintStyle } from './JobErrorBox.styles';

export interface JobErrorBoxProps {
  /** ingest_job.error 원문. */
  errorText: string;
  /** 제목 우측 안내. 예: "ingest_job.error — 실패 원인만 기록" (선택) */
  hint?: ReactNode;
}

/** 에러 박스. FAILED Job의 실패 원인 표시에 활용 — 실행 로그는 저장하지 않음. */
export function JobErrorBox({ errorText, hint }: JobErrorBoxProps) {
  return (
    <PanelCard tone="danger" title="에러" headerRight={hint !== undefined && <span css={hintStyle}>{hint}</span>}>
      <CodeBlock tone="danger">{errorText}</CodeBlock>
    </PanelCard>
  );
}
